export enum PickupLogPath {
  pickupNumber = "pickupNumber",
}

export interface PathParams {
  [PickupLogPath.pickupNumber]: string;
}
